module.exports = __webpack_public_path__ + "static/media/foood-chain-blockchain-and-robotics-mobile.c6ac2d0a.jpg";